import React, { useContext, useState } from "react";
import "./Achievement.scss";
import AchievementCard from "../../components/achievementCard/AchievementCard";
import { achievementSection } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import { useTranslation } from "react-i18next";

export default function Achievement() {
  const { isDark } = useContext(StyleContext);
  const [filter, setFilter] = useState("All");
  const { t } = useTranslation();

  if (!achievementSection.display) {
    return null;
  }

  const trackFilterClick = (category) => {
    if (window.gtag) {
      window.gtag("event", "achievement_filter_click", {
        event_category: "engagement",
        event_label: category,
      });
    }
  };

  // Utilisation des traductions pour les filtres
  const translatedTypes = {
    All: t("achievement.filter.all"),
    WEB: t("achievement.filter.web"),
    Cloud: t("achievement.filter.cloud"),
    Devops: t("achievement.filter.devops"),
    Others: t("achievement.filter.others"),
  };

  const categoryOrder = ["All", "WEB", "Cloud", "Devops", "Others"];

  const allTypes = categoryOrder.filter(
    (type) =>
      type === "All" ||
      achievementSection.achievementsCards.some((card) => card.type === type)
  );

  const filteredCards =
    filter === "All"
      ? achievementSection.achievementsCards
      : achievementSection.achievementsCards.filter(
          (card) => card.type === filter
        );

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="certifications">
        <div className="achievement-main-div">
          <div className="achievement-header">
            <h1
              className={
                isDark
                  ? "dark-mode heading achievement-heading"
                  : "heading achievement-heading"
              }
            >
              {t("achievement.title")}
            </h1>
            <p
              className={
                isDark
                  ? "dark-mode subTitle achievement-subtitle"
                  : "subTitle achievement-subtitle"
              }
            >
              {t("achievement.subtitle")}
            </p>

            {/* 🔘 Filtres traduits */}
            <div
              className={`achievement-filter-buttons ${
                isDark ? "dark-mode" : ""
              }`}
            >
              {allTypes.map((type) => (
                <button
                  key={type}
                  className={`filter-btn ${filter === type ? "active" : ""}`}
                  onClick={() => {
                    setFilter(type);
                    trackFilterClick(type);
                  }}
                >
                  {translatedTypes[type]}
                </button>
              ))}
            </div>
          </div>

          <div className="achievement-cards-div">
            {filteredCards.length > 0 ? (
              filteredCards.map((card, i) => (
                <AchievementCard
                  key={i}
                  isDark={isDark}
                  cardInfo={{
                    title: card.title,
                    description: card.subtitle,
                    image: card.image,
                    imageAlt: card.imageAlt,
                    footer: card.footerLink,
                  }}
                />
              ))
            ) : (
              <p className="no-results">{t("achievement.noResults")}</p>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
